import { createTheme } from '@mui/material';

export const hssrTheme = createTheme({
    typography: {
        fontFamily: [
            'Raleway',
        ].join(','),
        fontSize: 16,
    },
});

export type HssrKey = {
    hssrKey: string;
}

export interface HssrParams {
    memberId: string;
    memberName: string;
    answer1: boolean;
    answer2: boolean;
    answer3: boolean;
    language?: string;
}

export interface FormStatus {
    completed: boolean;
    completedOn: Date | null;
}

export const defaultFormStatus: FormStatus = {
    completed: false,
    completedOn: null,
};